export default [
  {
    path: '/parametrizacao-geral',
    name: 'parametrizacaogeral',
    component: () => import('@/app-modulo/comercial/Parametrizacao/ParametrizacaoGeral/Geral/ParametrizacaoGeral.vue'),
    meta: {
      resource: 'parametrizacaogeral',
      action: 'create',
      pageTitle: 'Parametrizações Gerais',
      breadcrumb: [],
    },
  },
]
